export default "__VITE_ASSET__gzVlMyfH__"